import { Button } from "@fluentui/react-components";
const Spinny = (props: { text?: string }) => {
    return (
        <>
            <div className="position-fixed top-0 start-0 w-100 h-100" style={{ backgroundColor: 'rgba(0,0,0,0.2)' }}></div>
            <div className="position-fixed d-flex flex-column align-items-center justify-content-center vh-100 vw-100" style={{ zIndex: 10500 }}>
                <img
                    alt="spinny"
                    src={"./images/rev_loading_small.gif"}
                />
                <div className="ms-3">{props.text}</div>
            </div>
        </>
    );
};

const PartialSpinny = (props: { text?: string; showCancel?: boolean; z?: number; canceled?: () => void, small?: boolean }) => {

    return (
        <>
            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ backgroundColor: 'rgba(0,0,0,0.2)', zIndex: props.z || 10500 }}>
                <div className="d-flex flex-column  align-items-center justify-content-center h-100 w-100">
                    <img
                        alt="spinny"
                        src={"./images/rev_loading_small.gif"}
                        width={props.small ? 32 : undefined}
                        height={props.small ? 32 : undefined}
                    />
                    {props.text && <div className="ms-3">{props.text}</div>}
                    {props.showCancel && <div className="m-2"><Button size='small' title='Cancel' onClick={props.canceled}>Cancel</Button></div>}
                </div>
            </div>
        </>
    );
};

const SimpleSpinny = (props: { text?: string }) => {
    return (
        <>
            <div className="d-flex align-items-center justify-content-center h-100 w-100">
                <img
                    alt="spinny"
                    src={"./images/rev_loading_small.gif"}
                />
                {props.text && <div className="ms-3">{props.text}</div>}
            </div>
        </>
    );
};


export { Spinny, PartialSpinny, SimpleSpinny };

